<template>
<div>
    <Cover>
        <h1>Frequently Asked Questions</h1>
    </Cover>
    <InvestorBody>
        <div>
            <Accordian>
                <template v-slot:header>
                    <h1 class="cursor-pointer">Who are we?</h1>
                </template>
                <template v-slot:body>
                    <p class="list-item">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</p>
                </template>
            </Accordian>
            <Accordian>
                <template v-slot:header>
                    <h1 class="cursor-pointer">What is Kolkin?</h1>
                </template>
                <template v-slot:body>
                    <p class="list-item">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</p>
                </template>
            </Accordian>
            <Accordian>
                <template v-slot:header>
                    <h1 class="cursor-pointer">Why Invest In Us?</h1>
                </template>
                <template v-slot:body>
                    <p class="list-item">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</p>
                </template>
            </Accordian>
        </div>
    </InvestorBody>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import store from "@/store"
import Accordian from "@/../submodules/vue-base/components/Accordian"
import Cover from "@/components/layout/Cover.vue";
import InvestorBody from "@/components/layout/InvestorBody.vue";

export default {
    name: "FAQ",

    components: {
        Accordian,
        Cover,
        InvestorBody
    },

    beforeRouteEnter(to, from, next) {
        if (store.state.user.user.is_investor) {
            next();
        } else {
            if (process.env.NODE_ENV === 'production') {
                window.location = '/signin';
            } else {
                window.location = 'http://localhost:8082/';
            }
        }
    },

    beforeRouteUpdate(to, from, next) {
        if (store.state.user.user.is_investor) {
            next();
        } else {
            if (process.env.NODE_ENV === 'production') {
                window.location = '/signin';
            } else {
                window.location = 'http://localhost:8082/';
            }
        }
    }
};
</script>

<style lang="less" scoped>
.cover-div {
    background: linear-gradient(to bottom right, rgb(255, 0, 0), rgb(255, 145, 0), rgb(255, 238, 0));

    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    padding-top: 7rem;
    height: 20rem;
}
</style>
